import React, { memo } from 'react';

import { Checkbox } from '@mint-lib/tw-components';

import { TableDataFileValidatedRow, ValidatedCell } from '../../api/types.js';
import { TableBodyCell, TableRow } from './TableComponents.jsx';

type ValidatedRowProps = {
  row: TableDataFileValidatedRow;
  isSelected: boolean;
  handleSelectRow: (checked: boolean) => void;
  children: (args: {
    cell: ValidatedCell;
    colIndex: number;
  }) => React.ReactNode;
};

export const ValidatedRow = memo(
  ({ row, isSelected, handleSelectRow, children }: ValidatedRowProps) => {
    return (
      <TableRow selected={isSelected}>
        <TableBodyCell>
          <Checkbox
            checked={isSelected}
            onCheckedChange={(checked) => handleSelectRow(checked === true)}
            aria-label="Select row"
            className="cursor-pointer"
          />
        </TableBodyCell>
        {row.validatedCells.map((cell, colIndex) =>
          children({ cell, colIndex }),
        )}
      </TableRow>
    );
  },
  (prevProps, nextProps) => {
    return (
      prevProps.isSelected === nextProps.isSelected &&
      prevProps.row.validatedCells.every(
        (cell, index) => cell === nextProps.row.validatedCells[index],
      )
    );
  },
);
